<script setup lang="ts">
import type { PropType } from "vue";

import type { User } from "~/common/interfaces/entities/user.interface";
import { useModalStore } from "~/stores/modal";

defineProps({
	users: {
		type: Array as PropType<User[]>,
		default () {
			return [];
		}
	}
});

const { teamModalInvite } = useModalStore();
</script>

<template>
	<div>
		<span class="px-2 font-semibold text-sm text-gray-500">
			{{ $t('COMPONENTS.LAYOUT.SIDE.TEAM.title') }}
		</span>
		<ul class="mt-2 flex flex-col gap-x-[2px]">
			<LayoutSideTeamItem
				v-for="user in users"
				:key="user.id"
				:name="user.email"
			/>
			<LayoutSideTeamInvite
				@click="teamModalInvite.openModal"
			/>
		</ul>
	</div>
</template>
